import { ReactNode } from 'react';
import cx from 'clsx';
import { MantineSpacing, Paper, UnstyledButton } from '@mantine/core';

import classes from './SelectableCard.module.css';

type SelectableCardProps = {
  isSelected: boolean;
  onSelect: () => void;
  children: ReactNode;

  variant?: 'flat' | 'card';
  py?: MantineSpacing;
  className?: string;
};

const SelectableCard: React.FC<SelectableCardProps> = ({
  isSelected,
  onSelect,
  children,
  variant = 'flat',
  py = 'xs',
  className,
}) => {
  const isCard = variant === 'card';

  const flatBg = isSelected ? 'white' : 'transparent';
  const flatBorder = isSelected ? '1px solid gray.5' : '1px solid transparent';

  return (
    <UnstyledButton w="100%" onClick={onSelect} className={cx(classes.button, className)}>
      <Paper
        px="sm"
        py={py}
        radius="sm"
        className={isCard ? cx(classes.card, { [classes.cardSelected]: isSelected }) : undefined}
        bg={isCard ? undefined : flatBg}
        bd={flatBorder}
        shadow={isSelected ? 'xs' : undefined}
      >
        {children}
      </Paper>
    </UnstyledButton>
  );
};

export default SelectableCard;
